import routerParams from 'config/routerParams';
import { ListRouteParams } from '@nextiva/engagement-ui';
import { ALL as ALL_TEMPLATES } from 'constants/templateList/TemplateTabKeys';
import { ALL as ALL_SURVEYS } from 'constants/surveyList/SurveyTabKeys';

const { PAGE_PARAM, TAB_PARAM } = ListRouteParams;
const listParamsPath = `/:${PAGE_PARAM}/:${TAB_PARAM}`;

const {
  surveyListPageNumber,
  entityId,
  previewPageNumber,
  surveyListTabName,
  surveyTemplateListPageNumber,
  errorType,
  entityType,
} = routerParams;

const restrictParamToInteger = param => `${param}([0-9]+)`;
const makeParamOptional = param => `${param}?`;

export const previewPath = '/preview';
export const quickViewPath = '/quick-view';
export const reportPath = '/report';
export const surveyListRoot = '/surveys';
export const surveyEditorRoot = '/survey';
export const surveyTemplateListRoot = '/templates';
export const surveyTemplateEditorRoot = '/template';
export const surveyCreationWizard = '/new-survey-wizard';
export const surveyCreationWizardAllTemplates = `${surveyCreationWizard}/all-templates`;
export const surveyCreationWizardFavouriteTemplates = `${surveyCreationWizard}/favourite-templates`;
export const surveyCreationWizardMyTemplates = `${surveyCreationWizard}/my-templates`;
export const surveyCreationWizardPlatformTemplates = `${surveyCreationWizard}/platform-templates`;
export const surveyCreationWizardChooseTemplate = `${surveyCreationWizard}/choose-template`;
export const questionBank = '/question-bank';

export const errorRoot = '/error';

export const quickView = `${quickViewPath}/:${entityType}/:${makeParamOptional(
  restrictParamToInteger(entityId),
)}`;

export const surveyList = `${surveyListRoot}/:${restrictParamToInteger(
  surveyListPageNumber,
)}/:${surveyListTabName}`;

export const surveyEditor = `${surveyEditorRoot}/:${restrictParamToInteger(
  entityId,
)}`;

export const surveyPreview = `${previewPath}/:${makeParamOptional(
  restrictParamToInteger(previewPageNumber),
)}`;

export const templateEditor = `${surveyTemplateEditorRoot}/:${restrictParamToInteger(
  entityId,
)}`;

export const surveyTemplateList = `${surveyTemplateListRoot}/:${makeParamOptional(
  restrictParamToInteger(surveyTemplateListPageNumber),
)}`;

export const defaultTemplateListPath = `${surveyTemplateListRoot}/1/${ALL_TEMPLATES}`;

export const templateListWithParams = `${surveyTemplateListRoot}${listParamsPath}`;

export const defaultPath = `${surveyListRoot}/1/all`;

export const errorPath = `${errorRoot}/:${makeParamOptional(errorType)}`;

export const defaultSurveyList = `${surveyListRoot}/1/${ALL_SURVEYS}`;

export const surveyListWithParams = `${surveyListRoot}${listParamsPath}`;
